export default __webpack_public_path__ + "static/linda-de-wit-25c1ddf77eb120107c5a173cfc696a73.jpg";